import { View, Text } from "reshaped";
import { ListLenguajeProps } from "./ListLenguaje.types";
import { Draggable, Droppable } from "@hello-pangea/dnd";
import { ItemLenguajes } from "./ItemLenguajes";
import { useResponsiveClientValue } from "../../hooks";

export const ListLenguaje = (props: ListLenguajeProps) => {
  const { list } = props;
  const responsiveColumns: any | undefined = useResponsiveClientValue({
    s: 12,
    m: 6,
    l: 4,
  });
  return (
    <Droppable droppableId="lenguages">
      {(droppableProvider) => (
        <div
          ref={droppableProvider.innerRef}
          {...droppableProvider.droppableProps}
        >
          <View gap={5}>
            <Text variant="featured-1" weight="bold">
              Mis lenguajes
            </Text>

            <View direction="row" gap={5}>
              {list.map((item, index) => (
                <View.Item columns={responsiveColumns}>

                <Draggable
                  index={index}
                  key={item.technologies.id}
                  draggableId={`${item.technologies.id}`}
                >
                  {(provided) => (
                    <ItemLenguajes
                      technology={item}
                      key={item.technologies.id}
                      ref={provided.innerRef}
                      {...provided.dragHandleProps}
                      {...provided.draggableProps}
                    />
                  )}
                </Draggable>
                </View.Item>
              ))}
              {droppableProvider.placeholder}
            </View>
          </View>
         
        </div>
      )}
    </Droppable>
  );
};
